import React from 'react'
import whatsappIcon from '@/components/ui/whatsapp'

type Props = {
  phone: string
  message?: string
  side?: 'left' | 'right'
  className?: string
  alt?: string
}

function digits(s: string) {
  return s.replace(/\D/g, '')
}

export default function WhatsAppFab({
  phone,
  message = 'Olá! Gostaria de mais informações.',
  side = 'left',
  className = '',
  alt = 'WhatsApp',
}: Props): React.ReactElement {
  const href = `https://wa.me/${digits(phone)}?text=${encodeURIComponent(
    message,
  )}`

  const pos: React.CSSProperties =
    side === 'left' ? { left: 20 } : { right: 20 }

  const baseStyle: React.CSSProperties = {
    position: 'fixed',
    bottom: 20,
    ...pos,
    zIndex: 2147483647,
    backgroundColor: '#25D366',
    color: '#FFFFFF',
    borderRadius: 9999,
    padding: 14,
    boxShadow: '0 8px 24px rgba(0,0,0,.25)',
    lineHeight: 0,
  }

  const isUrl = typeof whatsappIcon === 'string'
  const IconComp = whatsappIcon as unknown as React.ComponentType<
    React.SVGProps<SVGSVGElement>
  >

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contato WhatsApp"
      style={baseStyle}
      className={className}
    >
      {isUrl ? (
        <img
          src={whatsappIcon as unknown as string}
          alt={alt}
          width={28}
          height={28}
          style={{ display: 'block' }}
        />
      ) : (
        <IconComp width={28} height={28} aria-hidden="true" />
      )}

      <span
        style={{
          position: 'absolute',
          width: 1,
          height: 1,
          overflow: 'hidden',
          clip: 'rect(0 0 0 0)',
          whiteSpace: 'nowrap',
        }}
      >
        Abrir conversa no WhatsApp
      </span>
    </a>
  )
}
